import React, { useState } from "react";
import { useSelector } from "react-redux";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import TextField from "@material-ui/core/TextField";
import instance from "../../../store/actions/instance";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ReactComponent as Error } from "../../CheckoutProcess/assets/close.svg";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { getCurrencyIso } from "../../../Helpers/currencyConverter";

const PromoAPI = (code) =>
  instance.post("coupon/", { code: code, is_b2b: true });
const PromoAPIDebounced = AwesomeDebouncePromise(PromoAPI, 1000);

const AppliedCoupons = ({ promotion, handlePromotion }) => {
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const [promotionAvaliable, setPromotionAvaliable] = useState(false);

  const language = useSelector((state) => state.store.language);
  const currency_decimals = useSelector(
    (state) => state.store.store.settings.currency_decimals
  );
  const currency_english = useSelector(
    (state) => state.store.store.settings.currency_english
  );
  const currency_local = useSelector(
    (state) => state.store.store.settings.currency_local
  );
  const settings = useSelector((state) => state.store.store.settings);

  const handleTextChange = async (code) => {
    setLoading(true);
    setFailed(false);
    try {
      const result = await PromoAPIDebounced(code);
      handlePromotion(result.data);
      setLoading(false);
      setPromotionAvaliable(true);
    } catch {
      setLoading(false);
      setFailed(true);
    }
  };

  const currencyIso = getCurrencyIso(settings,language)
  const promoSubtitleRender = () => {
    if (promotion?.discount_type === "delivery") {
      return "Free delivery";
    } else if (promotion?.discount_type === "percent") {
      return `${parseInt(promotion?.discount_amount)}% off`;
    } else if (promotion?.discount_type === "fixed") {
      return `${promotion?.discount_amount.toFixed(currency_decimals)} ${
        currencyIso
      } off`;
    }
  };

  const promoSubtitleRenderArabic = () => {
    if (promotion?.discount_type === "delivery") {
      return "توصيل مجاني";
    } else if (promotion?.discount_type === "percent") {
      return `خصم ${promotion?.discount_amount}%`;
    } else if (promotion?.discount_type === "fixed") {
      return `خصم ${promotion?.discount_amount.toFixed(currency_decimals)} ${
        currencyIso
      }`;
    }
  };
  return (
    <div
      className="w-100"
      style={{
        backgroundColor: "white",
        marginTop: 5,
      }}
    >
      <p
        className={"pt-3 ".concat(
          language === "english" ? "text-left pl-3" : "text-right pr-3"
        )}
        dir={language === "english" ? "ltr" : "rtl"}
      >
        <span
          style={{
            marginRight: language === "english" && 10,
            marginLeft: language === "arabic" && 10,
          }}
        >
          <LocalOfferOutlinedIcon
            style={{
              color: "#5b5b5b",
            }}
          />
        </span>
        {language === "english" ? "Promotion" : "العروض"}
      </p>
      <div
        className="mx-auto"
        style={{
          width: "92%",
          display: "grid",
          gridTemplateColumns: "auto 35px",
          direction: language === "arabic" ? "rtl" : "ltr",
        }}
      >
        {promotionAvaliable ? (
          <>
            <div
              style={{
                marginBottom: 15,
              }}
              className={language === "arabic" ? "text-right" : "text-left"}
            >
              <p className="mb-1 bold">
                {language === "english" ? "Code:" : "الرمز:"} {promotion.code}
              </p>

              <p
                style={{
                  color: "#737373",
                  display: "block",
                  paddingLeft: language === "english" && 24,
                  paddingRight: language === "arabic" && 24,
                  marginBottom: 0,
                }}
                dir={language === "english" ? "ltr" : "rtl"}
              >
                {language === "english"
                  ? promoSubtitleRender()
                  : promoSubtitleRenderArabic()}
              </p>
            </div>
            <div>
              <DeleteForeverIcon
                onClick={() => {
                  setPromotionAvaliable(false);
                  handlePromotion(null);
                }}
                width={25}
                height={25}
                style={{
                  cursor: "pointer",
                  color: "#ff4242",
                }}
              />
            </div>
          </>
        ) : (
          <>
            <TextField
              id="promotionTextField"
              label={
                language === "english"
                  ? "Enter promotion code"
                  : "ادخل رمز الكوبون"
              }
              color="primary"
              key={"promotion"}
              name="promotion"
              fullWidth
              style={{
                marginBottom: 15,
              }}
              onChange={(e) => handleTextChange(e.target.value)}
              InputLabelProps={{
                style: {
                  right: language === "arabic" && 5,
                  left: language === "arabic" && "auto",
                },
                dir: language === "english" ? "ltr" : "rtl",
              }}
              InputProps={{
                dir: language === "english" ? "ltr" : "rtl",
              }}
            />

            {(loading || failed) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {loading && (
                  <CircularProgress style={{ width: 20, height: 20 }} />
                )}
                {failed && <Error width={18} height={18} />}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AppliedCoupons;
